import { Route } from '@angular/router';

export const UserRoutes: Route[] = [
  {
    path: 'user',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/user/user.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/user/user-detail/user-detail.page'),
      },
    ],
  },
];
